import React from 'react'
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { routes, requestStatus } from '../constants';
import { Tab, TabSet, RoleForm, AccountInfoForm } from '../components';
import { RegisterActions } from '../actions';
import { formValidators } from '../utils';

const registerPages = [
    'SET_ROLE',
    'ACCOUNT_INFO'
];

const validateEmail = formValidators.email({
    message: 'Please provide a valid email address'
});

const validatePassword = formValidators.required({
    message: 'Please enter a password'
});

class RegistrationForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            step: 0,
            formError: {
                message: ''
            }
        };
    }

    getHandler(key, validate) {
        return event => {
            let value = event.target.value;
            let props = {
                valid: {}
            };
            props[key] = value;

            if (validate) {
                let validators = validate; //in case it's already an array
                if (!Array.isArray(validate)) {
                    validators = [
                        validate
                    ];
                }

                let isValid = validators.every((validator) => {
                    return validator(value);
                });

                props.valid[key] = isValid;
            }

            this.props.dispatch(RegisterActions.updateApplication(props));
        }
    }

    formError(err){
        this.setState({
            formError: err
        });
    }

    resetFormError() {
        this.setState({
            formError: {}
        });
    }

    next() {
        this.resetFormError();
        if (this.state.step < registerPages.length - 1) {
            this.setState({
                step: this.state.step + 1
            });
        } else {
            if (typeof this.props.onComplete === 'function') {
                this.props.onComplete(this.props.account);
            }

            this.props.dispatch(RegisterActions.registerNewUser(this.props.account));
        }
    }

    back() {
        this.setState({
            step: this.state.step ? this.state.step - 1 : 0
        });
    }

    submitRoleHandler(event) {
        if (this.props.account.role) {
            this.next();
        }
        event.preventDefault();
    }

    submitAccountInfoHandler(event) {
        event.preventDefault();
        let emailErr = validateEmail(this.props.account.email);
        if (emailErr) {
            this.formError(emailErr);
            return;
        }

        let passErr = validatePassword(this.props.account.password);
        if (passErr) {
            this.formError(passErr);
            return;
        }

        if (this.props.account.password != this.props.account.confirmPassword) {
            this.formError({
                message: 'Confirmation password doesn\'t match'
            });
            return;
        }
        this.next();
    }

    resetForm() {
        this.props.dispatch(RegisterActions.resetApplication());
        browserHistory.push(routes.LOGIN);
    }

    accountInfoHandler(key, props) {
        this.props.dispatch(RegisterActions.updateApplication(props));
    }

    render () {
        let err = this.state.formError;
        if (this.props.registerStatus.status === requestStatus.ERROR) {
            err = {
                message: 'Registration failed. Please try again.'
            };
        }

        return (
            <div>
                <TabSet switch={registerPages[this.state.step]}>
                    <Tab value={registerPages[0]}>
                        <RoleForm onComplete={(event) => this.submitRoleHandler(event)} onChange={this.getHandler('role')} onCancel={() => this.resetForm()} value={this.props.account.role} />
                    </Tab>
                    <Tab value={registerPages[1]}>
                        <AccountInfoForm className="form-body" onComplete={(event) => this.submitAccountInfoHandler(event)} onChange={(key, props) => this.accountInfoHandler(key, props)} onCancel={() => this.back()} value={this.props.account} error={err}/>
                    </Tab>
                </TabSet>
            </div>
        )
    }
}

var select = state => {
    return {
        account: state.registerAccount,
        registerStatus: state.registerStatus
    }
}

export default connect(select)(RegistrationForm);



// WEBPACK FOOTER //
// ./web-app/components/registration-form.jsx